var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeutro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.988 0C5.364 0 0 5.376 0 12C0 18.624 5.364 24 11.988 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 11.988 0ZM6 9.00007C6 8.00596 6.80589 7.20007 7.8 7.20007C8.79411 7.20007 9.6 8.00596 9.6 9.00007C9.6 9.99419 8.79411 10.8001 7.8 10.8001C6.80589 10.8001 6 9.99419 6 9.00007ZM16.2 7.20007C15.2059 7.20007 14.4 8.00596 14.4 9.00007C14.4 9.99419 15.2059 10.8001 16.2 10.8001C17.1941 10.8001 18 9.99419 18 9.00007C18 8.00596 17.1941 7.20007 16.2 7.20007ZM8.40002 15.3C8.40002 15.792 8.80802 16.2 9.30002 16.2H14.7C15.192 16.2 15.6 15.792 15.6 15.3C15.6 14.808 15.192 14.4 14.7 14.4H9.30002C8.80802 14.4 8.40002 14.808 8.40002 15.3ZM2.40002 12C2.40002 17.304 6.69602 21.6 12 21.6C17.304 21.6 21.6 17.304 21.6 12C21.6 6.69596 17.304 2.39996 12 2.39996C6.69602 2.39996 2.40002 6.69596 2.40002 12Z",
    fill: "#FFB800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutro);
export default __webpack_public_path__ + "static/media/Neutro.83c39e7f0b21a76e319db18022fa9398.svg";
export { ForwardRef as ReactComponent };